import moment from "moment-timezone";
import React from "react";
import {inviteTemplates} from "./inviteTemplates/inviteTemplates";
import {
    capitalize,
    checkAndGetLocationLabel,
    checkAndGetLocationName,
    translateInviteTexts
} from "../functions";
import {
    introAnimation2PredefinedSets,
    introAnimation2ScreenTemplatesConfig,
    introAnimations
} from "./inviteTemplates/introAnimations/introAnimations";
import {corporateWeddingEvents} from "../const";

export const daysOfTheWeek = [
    'duminică',
    'luni',
    'marți',
    'miercuri',
    'joi',
    'vineri',
    'sâmbătă',
    'duminică',
]
export const months = [
    'ianuarie',
    'februarie',
    'martie',
    'aprilie',
    'mai',
    'iunie',
    'iulie',
    'august',
    'septembrie',
    'octombrie',
    'noiembrie',
    'decembrie',
]

export const daysOfTheWeekEn = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
]
export const monthsEnglish = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

export const daysOfTheWeekFr = [
    'dimanche',
    'lundi',
    'mardi',
    'mercredi',
    'thursday',
    'jeudi',
    'samedi',
    'dimanche',
]
export const monthsFrench = [
    'janvier',
    'février',
    'mars',
    'avril',
    'peut',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre',
]

export const daysOfTheWeekEs = [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado',
    'domingo',
]
export const monthsSpain = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'puede',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
]

export const daysOfTheWeekIt = [
    'domenica',
    'lunedi',
    'martedì',
    'mercoledì',
    'giovedì',
    'venerdì',
    'sabato',
    'domenica',
]
export const monthsItalian = [
    'gennaio',
    'febbraio',
    'marzo',
    'aprile',
    'maggio',
    'giugno',
    'luglio',
    'agosto',
    'settembre',
    'ottobre',
    'novembre',
    'dicembre',
]

export const daysOfTheWeekDe = [
    'sonntag',
    'montag',
    'dienstag',
    'mittwoch',
    'donnerstag',
    'freitag',
    'samstag',
    'sonntag',
]
export const monthsGerman = [
    'januar',
    'februar',
    'marsch',
    'april',
    'mai',
    'juni',
    'juli',
    'august',
    'september',
    'oktober',
    'november',
    'dezember',
]

export const daysOfTheWeekHu = [
    'vasárnap',
    'hétfő',
    'kedd',
    'szerda',
    'csütörtök',
    'péntek',
    'szombat',
    'vasárnap',
]
export const monthsHungarian = [
    'január',
    'február',
    'március',
    'április',
    'május',
    'június',
    'július',
    'augusztus',
    'szeptember',
    'október',
    'november',
    'december',
]

export const getDetailedDate = (date, weddingData = null) => {

    let lang = 'ro'
    if (weddingData && weddingData.invite && weddingData.invite.language && weddingData.invite.language.length > 0) {
        lang = weddingData.invite.language
    } else {
        lang = 'ro'
    }
    date = moment(date ? date : '')

    if (lang === 'ro') {

        if(weddingData && weddingData.id_eveniment === 'UQ3u5') {
            return {
                day: date.format('DD'),
                month: date.format('MM'),
                year: date.format('YYYY'),
                hour: date.format('HH'),
                minute: date.format('mm'),
                dayLiteral: capitalize(daysOfTheWeek[date.day()]),
                monthLiteral: capitalize(months[date.month()]),
                monthLiteralEn: capitalize(monthsEnglish[date.month()])
            }
        }


        return {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
            hour: date.format('HH'),
            minute: date.format('mm'),
            dayLiteral: daysOfTheWeek[date.day()],
            monthLiteral: months[date.month()],
            monthLiteralEn: monthsEnglish[date.month()]
        }
    }

    if (lang === 'en') {
        return {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
            hour: date.format('HH'),
            minute: date.format('mm'),
            dayLiteral: daysOfTheWeekEn[date.day()],
            monthLiteral: monthsEnglish[date.month()],
            monthLiteralEn: monthsEnglish[date.month()]
        }
    }

    if (lang === 'fr') {
        return {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
            hour: date.format('HH'),
            minute: date.format('mm'),
            dayLiteral: daysOfTheWeekFr[date.day()],
            monthLiteral: monthsFrench[date.month()],
            monthLiteralEn: monthsFrench[date.month()]
        }
    }

    if (lang === 'es') {
        return {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
            hour: date.format('HH'),
            minute: date.format('mm'),
            dayLiteral: daysOfTheWeekEs[date.day()],
            monthLiteral: monthsSpain[date.month()],
            monthLiteralEn: monthsSpain[date.month()]
        }
    }

    if (lang === 'it') {
        return {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
            hour: date.format('HH'),
            minute: date.format('mm'),
            dayLiteral: daysOfTheWeekIt[date.day()],
            monthLiteral: monthsItalian[date.month()],
            monthLiteralEn: monthsItalian[date.month()]
        }
    }

    if (lang === 'de') {
        return {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
            hour: date.format('HH'),
            minute: date.format('mm'),
            dayLiteral: daysOfTheWeekDe[date.day()],
            monthLiteral: monthsGerman[date.month()],
            monthLiteralEn: monthsGerman[date.month()]
        }
    }

    if (lang === 'hu') {
        return {
            day: date.format('DD'),
            month: date.format('MM'),
            year: date.format('YYYY'),
            hour: date.format('HH'),
            minute: date.format('mm'),
            dayLiteral: daysOfTheWeekHu[date.day()],
            monthLiteral: monthsHungarian[date.month()],
            monthLiteralEn: monthsHungarian[date.month()]
        }
    }


}

export const getFormattedLocationString = (location, weddingData, iconStyles = {}, lang = false) => {

    if (!lang && weddingData.invite.language && weddingData.invite.language.length > 0) {
        lang = weddingData.invite.language
    } else {
        lang = 'ro'
    }

    switch (location.name) {

        case 'Locatie biserica':
            return (<>
                <div className={'invite-location-icon'}>
                    <svg width="130" height="113" viewBox="0 0 130 113" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg"
                         style={iconStyles}
                    >
                        <rect x="0.85" y="109.85" width="128.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="126.85" y="112.15" width="87.3" height="2.3"
                              transform="rotate(-90 126.85 112.15)"
                              fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <rect x="99.85" y="112.15" width="87.3" height="2.3"
                              transform="rotate(-90 99.85 112.15)"
                              fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <rect x="27.85" y="112.15" width="86.3" height="2.3"
                              transform="rotate(-90 27.85 112.15)"
                              fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <rect x="0.85" y="24.8505" width="29.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <path
                            d="M0.878104 24.9306L0.792067 25.0534L0.91494 25.1395L2.55324 26.2866L2.67612 26.3727L2.76215 26.2498L16.8254 6.16546L16.9114 6.04259L16.7885 5.95655L15.1502 4.8094L15.0273 4.72336L14.9413 4.84623L0.878104 24.9306Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M16.0115 4.84414L15.9255 4.72127L15.8026 4.8073L14.1643 5.95446L14.0415 6.04049L14.1275 6.16337L28.1898 26.2465L28.2759 26.3694L28.3988 26.2833L30.0371 25.1362L30.1599 25.0501L30.0739 24.9273L16.0115 4.84414Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M99.8781 25.0004L99.7921 25.1233L99.9149 25.2093L101.553 26.3565L101.676 26.4425L101.762 26.3196L115.825 6.23528L115.911 6.11241L115.789 6.02637L114.15 4.87922L114.027 4.79318L113.941 4.91606L99.8781 25.0004Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M115.012 4.91396L114.926 4.79109L114.803 4.87713L113.164 6.02428L113.041 6.11032L113.127 6.23319L127.19 26.3163L127.276 26.4392L127.399 26.3531L129.037 25.206L129.16 25.12L129.074 24.9971L115.012 4.91396Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <rect x="0.85" y="31.8505" width="29.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="99.85" y="31.8505" width="29.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="99.85" y="24.8505" width="29.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="0.85" y="112.15" width="86.3" height="2.3"
                              transform="rotate(-90 0.85 112.15)"
                              fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <rect x="50.85" y="111.15" width="29.3" height="2.3"
                              transform="rotate(-90 50.85 111.15)"
                              fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M50.85 82.0005H51V82.1505H78V82.0005H78.15C78.15 80.8131 77.1874 79.8505 76 79.8505H53C51.8126 79.8505 50.85 80.8131 50.85 82.0005Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <rect x="75.85" y="111.15" width="29.3" height="2.3"
                              transform="rotate(-90 75.85 111.15)"
                              fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M10.318 45.3167V55.8257L19.7075 55.849L19.7192 45.3869L10.318 45.3167ZM10.228 42.8507H19.8573C21.1465 42.8507 22.1873 43.9256 22.1873 45.238V55.9754C22.1873 57.2869 21.1635 58.316 19.8573 58.316H10.228C8.91958 58.316 7.85 57.2686 7.85 55.9754V45.238C7.85 43.9424 8.93796 42.8507 10.228 42.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M10.318 67.3167V77.8257L19.7075 77.849L19.7192 67.3869L10.318 67.3167ZM10.228 64.8507H19.8573C21.1465 64.8507 22.1873 65.9256 22.1873 67.238V77.9754C22.1873 79.2869 21.1635 80.316 19.8573 80.316H10.228C8.91958 80.316 7.85 79.2686 7.85 77.9754V67.238C7.85 65.9424 8.93796 64.8507 10.228 64.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M38.318 60.3167V70.8257L47.7075 70.849L47.7192 60.3869L38.318 60.3167ZM38.228 57.8507H47.8573C49.1465 57.8507 50.1873 58.9256 50.1873 60.238V70.9754C50.1873 72.2869 49.1635 73.316 47.8573 73.316H38.228C36.9196 73.316 35.85 72.2686 35.85 70.9754V60.238C35.85 58.9424 36.938 57.8507 38.228 57.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M82.318 60.3167V70.8257L91.7075 70.849L91.7192 60.3869L82.318 60.3167ZM82.228 57.8507H91.8573C93.1465 57.8507 94.1873 58.9256 94.1873 60.238V70.9754C94.1873 72.2869 93.1635 73.316 91.8573 73.316H82.228C80.9196 73.316 79.85 72.2686 79.85 70.9754V60.238C79.85 58.9424 80.938 57.8507 82.228 57.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M60.318 60.3167V70.8257L69.7075 70.849L69.7192 60.3869L60.318 60.3167ZM60.228 57.8507H69.8573C71.1465 57.8507 72.1873 58.9256 72.1873 60.238V70.9754C72.1873 72.2869 71.1635 73.316 69.8573 73.316H60.228C58.9196 73.316 57.85 72.2686 57.85 70.9754V60.238C57.85 58.9424 58.938 57.8507 60.228 57.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M10.318 89.3167V99.8257L19.7075 99.849L19.7192 89.3869L10.318 89.3167ZM10.228 86.8507H19.8573C21.1465 86.8507 22.1873 87.9256 22.1873 89.238V99.9754C22.1873 101.287 21.1635 102.316 19.8573 102.316H10.228C8.91958 102.316 7.85 101.269 7.85 99.9754V89.238C7.85 87.9424 8.93796 86.8507 10.228 86.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M110.318 45.3167V55.8257L119.707 55.849L119.719 45.3869L110.318 45.3167ZM110.228 42.8507H119.857C121.147 42.8507 122.187 43.9256 122.187 45.238V55.9754C122.187 57.2869 121.163 58.316 119.857 58.316H110.228C108.92 58.316 107.85 57.2686 107.85 55.9754V45.238C107.85 43.9424 108.938 42.8507 110.228 42.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M110.318 67.3167V77.8257L119.707 77.849L119.719 67.3869L110.318 67.3167ZM110.228 64.8507H119.857C121.147 64.8507 122.187 65.9256 122.187 67.238V77.9754C122.187 79.2869 121.163 80.316 119.857 80.316H110.228C108.92 80.316 107.85 79.2686 107.85 77.9754V67.238C107.85 65.9424 108.938 64.8507 110.228 64.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <path
                            d="M110.318 89.3167V99.8257L119.707 99.849L119.719 89.3869L110.318 89.3167ZM110.228 86.8507H119.857C121.147 86.8507 122.187 87.9256 122.187 89.238V99.9754C122.187 101.287 121.163 102.316 119.857 102.316H110.228C108.92 102.316 107.85 101.269 107.85 99.9754V89.238C107.85 87.9424 108.938 86.8507 110.228 86.8507Z"
                            fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <rect x="40.7047" y="36.4606" width="30.6696" height="2.3"
                              transform="rotate(-37.5 40.7047 36.4606)" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="63.851" y="20.15" width="19.3" height="2.3"
                              transform="rotate(-90 63.851 20.15)"
                              fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                        <rect x="57.851" y="5.85" width="14.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="28.851" y="35.85" width="13.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="28.851" y="45.85" width="13.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="87.851" y="35.85" width="13.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="87.851" y="45.85" width="13.3" height="2.3" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="65.1911" y="17.7897" width="30.4963" height="2.3"
                              transform="rotate(37.5 65.1911 17.7897)" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="40.7448" y="46.4293" width="30.6185" height="2.3"
                              transform="rotate(-37.5 40.7448 46.4293)" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                        <rect x="65.1911" y="27.7897" width="30.5048" height="2.3"
                              transform="rotate(37.5 65.1911 27.7897)" fill="currentColor"
                              stroke="currentColor"
                              strokeWidth="0.3"/>
                    </svg>

                </div>
                <span>
                    {
                        weddingData.invite.id === 115974 ?
                            'A keresztelőre 11:00 órakor kerül sor a Kadicsfalvi Római Katólikus Szent Anna templomban.\nFenyő utca 10, Székelyudvarhely, Románia'
                            :
                            weddingData.invite.id === 123144 ?
                                'Cununia religioasă și botezul vor avea loc la':
                        weddingData.eventType === 'Nunta' || weddingData.eventType === 'Cununie' ?
                            translateInviteTexts('Cununia religioasă va avea loc la', lang)
                            : weddingData.eventType === 'Botez' ?
                                translateInviteTexts('Botezul va avea loc la', lang)
                                : '---'
                    }
                </span>

                {weddingData.invite.id === 115974 ? null :
                    <>
                <br/>
                <span>{checkAndGetLocationLabel(location, weddingData)}
                    <br/> {moment(location.day).format('DD-MM-YYYY') !== moment(weddingData.dataEvent).format('DD-MM-YYYY') ?
                        moment(location.combinedDate).format('DD-MM-YYYY HH:mm') : translateInviteTexts('la ora', lang, {date: moment(location.time).format('HH:mm')})} </span>
                    </>}
            </>)

        case 'Locatie cununie':
            return (<>
                <div className={'invite-location-icon'}>
                    <svg width="113" height="103" viewBox="0 0 113 103" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg"
                         style={iconStyles}>
                        <path
                            d="M10.3184 53.469C10.3184 52.401 11.1411 51.5664 12.1917 51.5664H16.3397C17.3891 51.5664 18.2091 52.401 18.2091 53.469V65.289H10.3184V53.469ZM9.23441 67.457H19.2944C19.8917 67.457 20.3771 66.9704 20.3771 66.3717V53.469C20.3771 51.225 18.5664 49.3997 16.3397 49.3997H12.1917C9.96373 49.3997 8.15039 51.225 8.15039 53.469V66.3717C8.15039 66.9704 8.63707 67.457 9.23441 67.457Z"
                            fill="currentColor"/>
                        <path
                            d="M10.3184 75.1837C10.3184 74.1517 11.1757 73.2811 12.1917 73.2811H16.3397C17.3544 73.2811 18.2091 74.1517 18.2091 75.1837V87.0037H10.3184V75.1837ZM9.23441 89.1704H19.2944C19.8917 89.1704 20.3771 88.6851 20.3771 88.0864V75.1837C20.3771 72.9397 18.5664 71.1131 16.3397 71.1131H12.1917C9.96373 71.1131 8.15039 72.9397 8.15039 75.1837V88.0864C8.15039 88.6851 8.63707 89.1704 9.23441 89.1704Z"
                            fill="currentColor"/>
                        <path
                            d="M41.0919 78.6733H33.2012V66.8546C33.2012 65.8226 34.0586 64.952 35.0732 64.952H39.2199C40.2359 64.952 41.0919 65.8226 41.0919 66.8546V78.6733ZM39.2199 62.784H35.0732C32.8466 62.784 31.0332 64.6106 31.0332 66.8546V79.7573C31.0332 80.356 31.5199 80.8413 32.1173 80.8413H42.1772C42.7745 80.8413 43.2599 80.356 43.2599 79.7573V66.8546C43.2599 64.6106 41.4479 62.784 39.2199 62.784"
                            fill="currentColor"/>
                        <path
                            d="M71.7676 66.8546C71.7676 65.8226 72.625 64.952 73.641 64.952H77.7863C78.8023 64.952 79.6583 65.8226 79.6583 66.8546V78.6733H71.7676V66.8546ZM70.6837 80.8413H80.7436C81.341 80.8413 81.8263 80.356 81.8263 79.7573V66.8546C81.8263 64.6106 80.0143 62.784 77.7863 62.784H73.641C71.413 62.784 69.5996 64.6106 69.5996 66.8546V79.7573C69.5996 80.356 70.085 80.8413 70.6837 80.8413"
                            fill="currentColor"/>
                        <path
                            d="M41.0919 50.6504H33.2012V38.8304C33.2012 37.801 34.0586 36.9304 35.0732 36.9304H39.2199C40.2359 36.9304 41.0919 37.801 41.0919 38.8304V50.6504ZM39.2199 34.7624H35.0732C32.8466 34.7624 31.0332 36.5864 31.0332 38.8304V51.7344C31.0332 52.3317 31.5199 52.8184 32.1173 52.8184H42.1772C42.7745 52.8184 43.2599 52.3317 43.2599 51.7344V38.8304C43.2599 36.5864 41.4479 34.7624 39.2199 34.7624"
                            fill="currentColor"/>
                        <path
                            d="M60.3995 50.6504H52.5075V38.8304C52.5075 37.7637 53.3302 36.9304 54.3795 36.9304H58.5275C59.5421 36.9304 60.3995 37.801 60.3995 38.8304V50.6504ZM58.5275 34.7624H54.3795C52.1528 34.7624 50.3408 36.5864 50.3408 38.8304V51.7344C50.3408 52.3317 50.8262 52.8184 51.4235 52.8184H61.4822C62.0822 52.8184 62.5675 52.3317 62.5675 51.7344V38.8304C62.5675 36.5864 60.7528 34.7624 58.5275 34.7624Z"
                            fill="currentColor"/>
                        <path
                            d="M71.7676 38.8304C71.7676 37.801 72.625 36.9304 73.641 36.9304H77.7863C78.8023 36.9304 79.6583 37.801 79.6583 38.8304V50.6504H71.7676V38.8304ZM70.6837 52.8184H80.7436C81.341 52.8184 81.8263 52.3317 81.8263 51.7344V38.8304C81.8263 36.5864 80.0143 34.7624 77.7863 34.7624H73.641C71.413 34.7624 69.5996 36.5864 69.5996 38.8304V51.7344C69.5996 52.3317 70.085 52.8184 70.6837 52.8184"
                            fill="currentColor"/>
                        <path
                            d="M60.115 78.7705H52.7949V69.4305H60.115V78.7705ZM61.1976 67.2625H51.7096C51.1123 67.2625 50.627 67.7491 50.627 68.3465V79.8545C50.627 80.4518 51.1123 80.9385 51.7096 80.9385H61.1976C61.7963 80.9385 62.2816 80.4518 62.2816 79.8545V68.3465C62.2816 67.7491 61.7963 67.2625 61.1976 67.2625Z"
                            fill="currentColor"/>
                        <path
                            d="M94.6494 53.469C94.6494 52.401 95.4735 51.5664 96.5228 51.5664H100.717C101.767 51.5664 102.588 52.401 102.588 53.469V65.289H94.6494V53.469ZM93.5667 67.457H103.673C104.271 67.457 104.756 66.9704 104.756 66.3717V53.469C104.756 51.225 102.944 49.3997 100.717 49.3997H96.5228C94.2961 49.3997 92.4814 51.225 92.4814 53.469V66.3717C92.4814 66.9704 92.9694 67.457 93.5667 67.457Z"
                            fill="currentColor"/>
                        <path
                            d="M94.6494 75.1837C94.6494 74.1517 95.5081 73.2811 96.5228 73.2811H100.717C101.732 73.2811 102.588 74.1517 102.588 75.1837V87.0037H94.6494V75.1837ZM93.5667 89.1704H103.673C104.271 89.1704 104.756 88.6851 104.756 88.0864V75.1837C104.756 72.9397 102.944 71.1131 100.717 71.1131H96.5228C94.2961 71.1131 92.4814 72.9397 92.4814 75.1837V88.0864C92.4814 88.6851 92.9694 89.1704 93.5667 89.1704Z"
                            fill="currentColor"/>
                        <path
                            d="M109.643 100.341H87.5946V94.9958H109.643V100.341ZM48.1707 100.341V94.9958H64.6907V100.341H48.1707ZM27.4813 94.9958H46.0026V100.341H27.4813V94.9958ZM3.21732 94.9958H25.3133V100.341H3.21732V94.9958ZM25.3133 27.0585V33.1252H7.59199L25.3133 27.0585ZM56.4293 2.37048L87.5586 22.4838H86.5106H83.4467L57.02 5.37315C56.6587 5.14248 56.2013 5.14248 55.8413 5.37315L29.4147 22.4838H26.3973H25.3026L56.4293 2.37048ZM105.279 33.1252H87.5946V27.0598L105.279 33.1252ZM85.4267 94.9958V100.341H66.8573V94.9958H85.4267ZM110.693 45.4505H87.5946V44.0078H110.693V45.4505ZM110.693 41.8398H87.5946V35.2931H110.693V41.8398ZM33.4 22.4838L56.4293 7.57448L79.4613 22.4838H33.4ZM25.3133 47.6185V92.8278H3.21732V47.6185H25.3133ZM25.3133 41.8398H2.168V35.2931H25.3133V41.8398ZM2.168 44.0078H25.3133V45.4505H2.168V44.0078ZM64.296 62.5438H48.5653C47.152 62.5438 46.0026 63.6998 46.0026 65.1198V92.8278H27.4813V46.5345V42.9225V34.2092V25.5425V24.6518H29.7347H83.1267H85.4267V25.5425V34.2092V42.9225V46.5345V92.8278H66.8573V65.1198C66.8573 63.6998 65.708 62.5438 64.296 62.5438V62.5438ZM64.6907 92.8278H48.1707V65.1198C48.1707 64.8971 48.352 64.7118 48.5653 64.7118H64.296C64.5093 64.7118 64.6907 64.8971 64.6907 65.1198V92.8278ZM109.643 92.8278H87.5946V47.6185H109.643V92.8278ZM112.843 34.1185C112.835 34.0358 112.819 33.9585 112.795 33.8811C112.777 33.8278 112.76 33.7785 112.736 33.7305C112.7 33.6585 112.655 33.5971 112.605 33.5358C112.572 33.4945 112.54 33.4518 112.501 33.4158C112.444 33.3625 112.376 33.3238 112.308 33.2851C112.259 33.2558 112.215 33.2238 112.161 33.2025C112.148 33.1985 112.141 33.1891 112.128 33.1851L87.5946 24.7691V24.6518H91.2306C91.7106 24.6518 92.1347 24.3358 92.2707 23.8758C92.4053 23.4145 92.2227 22.9198 91.8187 22.6585L57.0187 0.171816C56.66 -0.0575173 56.2 -0.0575173 55.8427 0.171816L21.0413 22.6585C20.6386 22.9198 20.456 23.4145 20.5894 23.8758C20.7267 24.3358 21.1493 24.6518 21.6306 24.6518H25.3133V24.7691L0.733333 33.1851C0.72 33.1891 0.710665 33.1985 0.698665 33.2025C0.645332 33.2238 0.60399 33.2545 0.55599 33.2825C0.485323 33.3225 0.417326 33.3625 0.358659 33.4171C0.318659 33.4518 0.290658 33.4918 0.257324 33.5318C0.205324 33.5958 0.159991 33.6585 0.123991 33.7305C0.0999909 33.7785 0.084 33.8278 0.0666667 33.8798C0.0413333 33.9585 0.0266523 34.0358 0.0186523 34.1198C0.0159857 34.1505 0 34.1772 0 34.2092V42.9225V45.7638C0 46.5105 0.431983 47.1505 1.04932 47.4451V93.9131V101.424C1.04932 102.022 1.536 102.508 2.13467 102.508H26.3973H47.0867H65.7733H86.5106H110.727C111.324 102.508 111.811 102.022 111.811 101.424V93.9131V47.4451C112.428 47.1505 112.861 46.5105 112.861 45.7638V42.9225V34.2092C112.861 34.1772 112.845 34.1491 112.843 34.1185"
                            fill="currentColor"/>
                    </svg>

                </div>
                <span>{weddingData.id_eveniment === 'Yu4Y0' ?
                    translateInviteTexts('Cununia civilă se va desfășura în', lang) : translateInviteTexts('Cununia civilă se va desfășura la', lang)}</span>
                <br/>
                {
                    weddingData && weddingData.id_eveniment === 'QJNK1' ?
                        <span>{checkAndGetLocationLabel(location, weddingData)}</span>
                        :
                    weddingData && weddingData.id_eveniment === 'lJtA3' ?
                        <span>{checkAndGetLocationLabel(location, weddingData)}</span>
                        :
                        <span>{checkAndGetLocationLabel(location, weddingData)}
                            <br/> {moment(location.day).format('DD-MM-YYYY') !== moment(weddingData.dataEvent).format('DD-MM-YYYY') ?
                                moment(location.combinedDate).format('DD-MM-YYYY HH:mm') :
                                translateInviteTexts('la ora', lang, {date: moment(location.time).format('HH:mm')})}</span>
                }
            </>)

        case 'Locatie petrecere':
            return (<>
                <div className={'invite-location-icon'}>
                    <svg width="119" height="82" viewBox="0 0 119 82" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg"
                         style={iconStyles}>
                        <path
                            d="M116.364 79.7816H2.16667V78.0013H116.364V79.7816ZM2.69066 22.1002H115.888V23.4002H2.69066V22.1002ZM6.98 14.5893H111.548V19.932H6.98V14.5893ZM19.948 7.07891H98.5827V12.4216H19.948V7.07891ZM18.4227 2.16798H100.108V4.91064H18.4227V2.16798ZM12.536 75.8336H7.55334V29.0336H12.536V75.8336ZM31.3173 75.8336H26.3827V29.0336H31.3173V75.8336ZM42.3653 74.1497H79.276V75.8336H39.2547V74.1497H42.3653ZM47.4667 70.3456H75.0813V71.9816H43.4493V70.3456H47.4667ZM69.98 33.9018V45.1644H48.5507V33.8977L69.98 33.9018ZM48.5507 47.331H69.98V68.1773H48.5507V47.331ZM92.1947 75.8336H87.2107V29.0336H92.1947V75.8336ZM112.061 26.8653H104.911C104.312 26.8653 103.827 27.3534 103.827 27.9508V75.8336H94.3627V27.9508C94.3627 27.3534 93.876 26.8653 93.2787 26.8653H86.1267C85.5293 26.8653 85.0427 27.3534 85.0427 27.9508V75.8336H81.444V73.4986C81.444 72.6346 80.8747 71.9816 80.1213 71.9816H77.2493V69.6472C77.2493 68.6934 76.5667 68.1773 75.9267 68.1773H72.148V46.2482V33.2482V32.9592C72.148 32.831 72.104 31.7294 70.5867 31.7294H47.848C46.692 31.7294 46.3827 32.4721 46.3827 32.9106V33.1497V46.2482V68.1773H42.604C41.964 68.1773 41.2813 68.6934 41.2813 69.6472V71.9816H38.4093C37.656 71.9816 37.0867 72.6346 37.0867 73.4986V75.8336H33.4853V27.9508C33.4853 27.3534 33 26.8653 32.4027 26.8653H25.2987C24.7013 26.8653 24.2147 27.3534 24.2147 27.9508V75.8336H14.704V27.9508C14.704 27.3534 14.2187 26.8653 13.62 26.8653H6.47067C5.872 26.8653 5.38667 27.3534 5.38667 27.9508V75.8336H3.59733V25.5685H114.933V75.8336H113.144V27.9508C113.144 27.3534 112.659 26.8653 112.061 26.8653ZM110.977 75.8336H105.995V29.0336H110.977V75.8336ZM117.101 75.8508V25.356C117.66 25.071 118.056 24.5164 118.056 23.8592V21.6414C118.056 20.6986 117.269 19.932 116.304 19.932H113.716V13.8909C113.716 13.0816 113.059 12.4216 112.252 12.4216H100.751V7.07891H101.192C101.789 7.07891 102.276 6.59251 102.276 5.99504V1.08411C102.276 0.485711 101.789 0.000240887 101.192 0.000240887H17.3387C16.7413 0.000240887 16.2547 0.485711 16.2547 1.08411V5.99504C16.2547 6.59251 16.7413 7.07891 17.3387 7.07891H17.7813V12.4216H6.28C5.472 12.4216 4.812 13.0816 4.812 13.8909V19.932H2.22533C1.28666 19.932 0.522673 20.6986 0.522673 21.6414V23.8592C0.522673 24.507 0.897329 25.0524 1.42933 25.3429V75.8508C0.635996 75.8961 0 76.544 0 77.3524V80.8653C0 81.4644 0.485334 81.9497 1.084 81.9497H117.448C118.045 81.9497 118.532 81.4644 118.532 80.8653V77.3524C118.532 76.544 117.895 75.8961 117.101 75.8508"
                            fill="currentColor"/>
                        <path
                            d="M55.3314 53.2043H50.4688C49.8701 53.2043 49.3848 53.6909 49.3848 54.2882C49.3848 54.8857 49.8701 55.3721 50.4688 55.3721H55.3314C55.9288 55.3721 56.4154 54.8857 56.4154 54.2882C56.4154 53.6909 55.9288 53.2043 55.3314 53.2043Z"
                            fill="currentColor"/>
                        <path
                            d="M20.5442 60.4257H18.1842V35.3907H20.5442V60.4257ZM21.6282 33.2225H17.1002C16.5029 33.2225 16.0176 33.7079 16.0176 34.3069V61.5094C16.0176 62.1069 16.5029 62.5933 17.1002 62.5933H21.6282C22.2256 62.5933 22.7122 62.1069 22.7122 61.5094V34.3069C22.7122 33.7079 22.2256 33.2225 21.6282 33.2225Z"
                            fill="currentColor"/>
                        <path
                            d="M41.044 60.4257H38.6826V35.3907H41.044V60.4257ZM42.128 33.2225H37.5986C37.0013 33.2225 36.5146 33.7079 36.5146 34.3069V61.5094C36.5146 62.1069 37.0013 62.5933 37.5986 62.5933H42.128C42.7253 62.5933 43.212 62.1069 43.212 61.5094V34.3069C43.212 33.7079 42.7253 33.2225 42.128 33.2225Z"
                            fill="currentColor"/>
                        <path
                            d="M79.6557 60.4257H77.2491V35.3907H79.6557V60.4257ZM80.7397 33.2225H76.1651C75.5664 33.2225 75.0811 33.7079 75.0811 34.3069V61.5094C75.0811 62.1069 75.5664 62.5933 76.1651 62.5933H80.7397C81.337 62.5933 81.8237 62.1069 81.8237 61.5094V34.3069C81.8237 33.7079 81.337 33.2225 80.7397 33.2225Z"
                            fill="currentColor"/>
                        <path
                            d="M100.155 60.4257H97.7461V35.3907H100.155V60.4257ZM101.239 33.2225H96.6621C96.0648 33.2225 95.5781 33.7079 95.5781 34.3069V61.5094C95.5781 62.1069 96.0648 62.5933 96.6621 62.5933H101.239C101.837 62.5933 102.323 62.1069 102.323 61.5094V34.3069C102.323 33.7079 101.837 33.2225 101.239 33.2225Z"
                            fill="currentColor"/>
                    </svg>

                </div>


                <span>{
                    weddingData.invite.id === 115974 ?
                        'Az ünnepi ebéd a Deság Resort Konferencia termében lesz  megtartva.'
                        :
                    translateInviteTexts('Vom petrece împreună la', lang)
                }</span>

                <br/>

                <span>{checkAndGetLocationLabel(location, weddingData)}
                    <br/> {moment(location.day).format('DD-MM-YYYY') !== moment(weddingData.dataEvent).format('DD-MM-YYYY') ?
                        moment(location.combinedDate).format('DD-MM-YYYY HH:mm') :
                        weddingData.invite.id === 120295 ?
                            translateInviteTexts('la ora', lang, {date: moment(location.time).format('HH:mm')}).replace('statt', '')
                            :
                        translateInviteTexts('la ora', lang, {date: moment(location.time).format('HH:mm')})} </span>
            </>)
        case 'Locatie eveniment':
            return (<>
                <div className={'invite-location-icon'}>
                    <svg width="129" height="77" viewBox="0 0 129 77" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg"
                         style={iconStyles}>
                        <path
                            d="M125.327 74.7738H91.0261V72.1244H125.327V74.7738ZM59.2292 74.7738V53.6844H69.5991V74.7738H59.2292ZM40.0177 71.0418V29.0804H47.5281V74.7738H40.0177V71.0418ZM3.54907 72.1244H37.8516V74.7738H3.54907V72.1244ZM37.8516 69.9591H3.54907V29.0804H37.8516V69.9591ZM125.482 26.9138H3.39587L3.1084 25.0351H125.77L125.482 26.9138ZM81.3495 29.0804H88.8584V74.7738H81.3495V29.0804ZM69.8729 51.5178H59.0047C57.9333 51.5178 57.0609 52.3711 57.0609 53.4191V74.7738H49.6959V29.0804H79.1819V74.7738H71.7667V53.4191C71.7667 52.3711 70.9177 51.5178 69.8729 51.5178V51.5178ZM125.327 69.9591H91.0261V29.0804H125.327V69.9591ZM2.16613 18.4391H126.709V22.8698H2.16613V18.4391ZM22.9991 14.1551H32.7751L28.0704 16.2738H22.9991V14.1551ZM64.4385 2.2711L90.56 14.0351C90.5729 14.0418 90.5824 14.0524 90.5959 14.0591L95.5213 16.2738H33.3563L38.2824 14.0591C38.2969 14.0524 38.3073 14.0404 38.3213 14.0324L64.4385 2.2711ZM105.878 14.1551V16.2738H100.807L96.1021 14.1551H105.878ZM127.03 16.2738H108.045V13.6964C108.045 12.7538 107.28 11.9884 106.341 11.9884H91.2933L64.8839 0.0950892C64.6016 -0.0315774 64.2761 -0.0315774 63.9933 0.0950892L37.5844 11.9884H22.5355C21.5964 11.9884 20.8328 12.7538 20.8328 13.6964V16.2738H1.84587C0.810399 16.2738 0 17.0871 0 18.1258V23.2311C0 23.8764 0.351066 24.4391 0.873466 24.7578L1.3828 28.0804V71.0418V75.8577C1.3828 76.4551 1.8672 76.9404 2.46613 76.9404H38.9344H58.1453H70.6828H89.9423H126.411C127.009 76.9404 127.495 76.4551 127.495 75.8577V71.0418V28.0764L128.003 24.7578C128.526 24.4391 128.877 23.8764 128.877 23.2311V18.1258C128.877 17.0871 128.065 16.2738 127.03 16.2738"
                            fill="currentColor"/>
                        <path
                            d="M67.5968 46.8949H61.2785V34.0882H67.5968V46.8949ZM68.1567 31.9215H60.6728C59.7823 31.9215 59.1113 32.5935 59.1113 33.4855V47.4482C59.1113 48.3535 59.7973 49.0615 60.6728 49.0615H68.1567C69.0436 49.0615 69.7651 48.3375 69.7651 47.4482V33.4855C69.7651 32.6082 69.0588 31.9215 68.1567 31.9215Z"
                            fill="currentColor"/>
                        <path
                            d="M10.3185 34.0882H16.6857V46.8949H10.3185V34.0882ZM9.76074 49.0615H17.2441C18.131 49.0615 18.8523 48.3375 18.8523 47.4482V33.4855C18.8523 32.6082 18.1461 31.9215 17.2441 31.9215H9.76074C8.85914 31.9215 8.15234 32.6082 8.15234 33.4855V47.4482C8.15234 48.3375 8.87314 49.0615 9.76074 49.0615"
                            fill="currentColor"/>
                        <path
                            d="M24.7633 34.0882H31.13V46.8949H24.7633V34.0882ZM24.204 49.0615H31.6888C32.5748 49.0615 33.2956 48.3375 33.2956 47.4482V33.4855C33.2956 32.6082 32.5899 31.9215 31.6888 31.9215H24.204C23.3024 31.9215 22.5967 32.6082 22.5967 33.4855V47.4482C22.5967 48.3375 23.318 49.0615 24.204 49.0615Z"
                            fill="currentColor"/>
                        <path
                            d="M10.3185 53.2029H16.6857V66.0109H10.3185V53.2029ZM9.76074 68.1763H17.2441C18.1461 68.1763 18.8523 67.4896 18.8523 66.6123V52.6496C18.8523 51.7603 18.131 51.0363 17.2441 51.0363H9.76074C8.87314 51.0363 8.15234 51.7603 8.15234 52.6496V66.6123C8.15234 67.4896 8.85914 68.1763 9.76074 68.1763"
                            fill="currentColor"/>
                        <path
                            d="M24.7633 53.2029H31.13V66.0109H24.7633V53.2029ZM24.204 68.1763H31.6888C32.5899 68.1763 33.2956 67.4896 33.2956 66.6123V52.6496C33.2956 51.7603 32.5748 51.0363 31.6888 51.0363H24.204C23.318 51.0363 22.5967 51.7603 22.5967 52.6496V66.6123C22.5967 67.4896 23.3024 68.1763 24.204 68.1763Z"
                            fill="currentColor"/>
                        <path
                            d="M97.7483 34.0882H104.066V46.8949H97.7483V34.0882ZM97.1409 49.0615H104.673C105.519 49.0615 106.235 48.3242 106.235 47.4482V33.4855C106.235 32.6228 105.533 31.9215 104.673 31.9215H97.1409C96.2805 31.9215 95.5811 32.6228 95.5811 33.4855V47.4482C95.5811 48.3242 96.2951 49.0615 97.1409 49.0615Z"
                            fill="currentColor"/>
                        <path
                            d="M112.193 34.0882H118.51V46.8949H112.193V34.0882ZM111.585 49.0615H119.069C119.956 49.0615 120.678 48.3375 120.678 47.4482V33.4855C120.678 32.6082 119.972 31.9215 119.069 31.9215H111.585C110.697 31.9215 110.025 32.5935 110.025 33.4855V47.4482C110.025 48.3535 110.71 49.0615 111.585 49.0615"
                            fill="currentColor"/>
                        <path
                            d="M97.7483 53.2029H104.066V66.0109H97.7483V53.2029ZM97.1409 68.1763H104.673C105.533 68.1763 106.235 67.4749 106.235 66.6123V52.6496C106.235 51.7749 105.519 51.0363 104.673 51.0363H97.1409C96.2951 51.0363 95.5811 51.7749 95.5811 52.6496V66.6123C95.5811 67.4749 96.2805 68.1763 97.1409 68.1763Z"
                            fill="currentColor"/>
                        <path
                            d="M112.193 53.2029H118.51V66.0109H112.193V53.2029ZM111.585 68.1763H119.069C119.972 68.1763 120.678 67.4896 120.678 66.6123V52.6496C120.678 51.7603 119.956 51.0363 119.069 51.0363H111.585C110.71 51.0363 110.025 51.7456 110.025 52.6496V66.6123C110.025 67.5043 110.697 68.1763 111.585 68.1763"
                            fill="currentColor"/>
                    </svg>

                </div>
                <span>{translateInviteTexts('Locatie eveniment', lang)}</span>
                <br/>
                <span>{checkAndGetLocationLabel(location, weddingData)}
                    <br/> {moment(location.day).format('DD-MM-YYYY') !== moment(weddingData.dataEvent).format('DD-MM-YYYY') ?
                        moment(location.combinedDate).format('DD-MM-YYYY HH:mm') :
                        translateInviteTexts('la ora', lang, {date: moment(location.time).format('HH:mm')})}</span>
            </>)
        default:
            return (<>
                <div className={'invite-location-icon'}>
                    {weddingData.id_eveniment === 'Noi3' ?
                        <svg width="130" height="113" viewBox="0 0 130 113" fill="currentColor"
                             xmlns="http://www.w3.org/2000/svg"
                             style={iconStyles}
                        >
                            <rect x="0.85" y="109.85" width="128.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="126.85" y="112.15" width="87.3" height="2.3"
                                  transform="rotate(-90 126.85 112.15)"
                                  fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <rect x="99.85" y="112.15" width="87.3" height="2.3"
                                  transform="rotate(-90 99.85 112.15)"
                                  fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <rect x="27.85" y="112.15" width="86.3" height="2.3"
                                  transform="rotate(-90 27.85 112.15)"
                                  fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <rect x="0.85" y="24.8505" width="29.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <path
                                d="M0.878104 24.9306L0.792067 25.0534L0.91494 25.1395L2.55324 26.2866L2.67612 26.3727L2.76215 26.2498L16.8254 6.16546L16.9114 6.04259L16.7885 5.95655L15.1502 4.8094L15.0273 4.72336L14.9413 4.84623L0.878104 24.9306Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M16.0115 4.84414L15.9255 4.72127L15.8026 4.8073L14.1643 5.95446L14.0415 6.04049L14.1275 6.16337L28.1898 26.2465L28.2759 26.3694L28.3988 26.2833L30.0371 25.1362L30.1599 25.0501L30.0739 24.9273L16.0115 4.84414Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M99.8781 25.0004L99.7921 25.1233L99.9149 25.2093L101.553 26.3565L101.676 26.4425L101.762 26.3196L115.825 6.23528L115.911 6.11241L115.789 6.02637L114.15 4.87922L114.027 4.79318L113.941 4.91606L99.8781 25.0004Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M115.012 4.91396L114.926 4.79109L114.803 4.87713L113.164 6.02428L113.041 6.11032L113.127 6.23319L127.19 26.3163L127.276 26.4392L127.399 26.3531L129.037 25.206L129.16 25.12L129.074 24.9971L115.012 4.91396Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <rect x="0.85" y="31.8505" width="29.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="99.85" y="31.8505" width="29.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="99.85" y="24.8505" width="29.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="0.85" y="112.15" width="86.3" height="2.3"
                                  transform="rotate(-90 0.85 112.15)"
                                  fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <rect x="50.85" y="111.15" width="29.3" height="2.3"
                                  transform="rotate(-90 50.85 111.15)"
                                  fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M50.85 82.0005H51V82.1505H78V82.0005H78.15C78.15 80.8131 77.1874 79.8505 76 79.8505H53C51.8126 79.8505 50.85 80.8131 50.85 82.0005Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <rect x="75.85" y="111.15" width="29.3" height="2.3"
                                  transform="rotate(-90 75.85 111.15)"
                                  fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M10.318 45.3167V55.8257L19.7075 55.849L19.7192 45.3869L10.318 45.3167ZM10.228 42.8507H19.8573C21.1465 42.8507 22.1873 43.9256 22.1873 45.238V55.9754C22.1873 57.2869 21.1635 58.316 19.8573 58.316H10.228C8.91958 58.316 7.85 57.2686 7.85 55.9754V45.238C7.85 43.9424 8.93796 42.8507 10.228 42.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M10.318 67.3167V77.8257L19.7075 77.849L19.7192 67.3869L10.318 67.3167ZM10.228 64.8507H19.8573C21.1465 64.8507 22.1873 65.9256 22.1873 67.238V77.9754C22.1873 79.2869 21.1635 80.316 19.8573 80.316H10.228C8.91958 80.316 7.85 79.2686 7.85 77.9754V67.238C7.85 65.9424 8.93796 64.8507 10.228 64.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M38.318 60.3167V70.8257L47.7075 70.849L47.7192 60.3869L38.318 60.3167ZM38.228 57.8507H47.8573C49.1465 57.8507 50.1873 58.9256 50.1873 60.238V70.9754C50.1873 72.2869 49.1635 73.316 47.8573 73.316H38.228C36.9196 73.316 35.85 72.2686 35.85 70.9754V60.238C35.85 58.9424 36.938 57.8507 38.228 57.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M82.318 60.3167V70.8257L91.7075 70.849L91.7192 60.3869L82.318 60.3167ZM82.228 57.8507H91.8573C93.1465 57.8507 94.1873 58.9256 94.1873 60.238V70.9754C94.1873 72.2869 93.1635 73.316 91.8573 73.316H82.228C80.9196 73.316 79.85 72.2686 79.85 70.9754V60.238C79.85 58.9424 80.938 57.8507 82.228 57.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M60.318 60.3167V70.8257L69.7075 70.849L69.7192 60.3869L60.318 60.3167ZM60.228 57.8507H69.8573C71.1465 57.8507 72.1873 58.9256 72.1873 60.238V70.9754C72.1873 72.2869 71.1635 73.316 69.8573 73.316H60.228C58.9196 73.316 57.85 72.2686 57.85 70.9754V60.238C57.85 58.9424 58.938 57.8507 60.228 57.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M10.318 89.3167V99.8257L19.7075 99.849L19.7192 89.3869L10.318 89.3167ZM10.228 86.8507H19.8573C21.1465 86.8507 22.1873 87.9256 22.1873 89.238V99.9754C22.1873 101.287 21.1635 102.316 19.8573 102.316H10.228C8.91958 102.316 7.85 101.269 7.85 99.9754V89.238C7.85 87.9424 8.93796 86.8507 10.228 86.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M110.318 45.3167V55.8257L119.707 55.849L119.719 45.3869L110.318 45.3167ZM110.228 42.8507H119.857C121.147 42.8507 122.187 43.9256 122.187 45.238V55.9754C122.187 57.2869 121.163 58.316 119.857 58.316H110.228C108.92 58.316 107.85 57.2686 107.85 55.9754V45.238C107.85 43.9424 108.938 42.8507 110.228 42.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M110.318 67.3167V77.8257L119.707 77.849L119.719 67.3869L110.318 67.3167ZM110.228 64.8507H119.857C121.147 64.8507 122.187 65.9256 122.187 67.238V77.9754C122.187 79.2869 121.163 80.316 119.857 80.316H110.228C108.92 80.316 107.85 79.2686 107.85 77.9754V67.238C107.85 65.9424 108.938 64.8507 110.228 64.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <path
                                d="M110.318 89.3167V99.8257L119.707 99.849L119.719 89.3869L110.318 89.3167ZM110.228 86.8507H119.857C121.147 86.8507 122.187 87.9256 122.187 89.238V99.9754C122.187 101.287 121.163 102.316 119.857 102.316H110.228C108.92 102.316 107.85 101.269 107.85 99.9754V89.238C107.85 87.9424 108.938 86.8507 110.228 86.8507Z"
                                fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <rect x="40.7047" y="36.4606" width="30.6696" height="2.3"
                                  transform="rotate(-37.5 40.7047 36.4606)" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="63.851" y="20.15" width="19.3" height="2.3"
                                  transform="rotate(-90 63.851 20.15)"
                                  fill="currentColor" stroke="currentColor" strokeWidth="0.3"/>
                            <rect x="57.851" y="5.85" width="14.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="28.851" y="35.85" width="13.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="28.851" y="45.85" width="13.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="87.851" y="35.85" width="13.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="87.851" y="45.85" width="13.3" height="2.3" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="65.1911" y="17.7897" width="30.4963" height="2.3"
                                  transform="rotate(37.5 65.1911 17.7897)" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="40.7448" y="46.4293" width="30.6185" height="2.3"
                                  transform="rotate(-37.5 40.7448 46.4293)" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                            <rect x="65.1911" y="27.7897" width="30.5048" height="2.3"
                                  transform="rotate(37.5 65.1911 27.7897)" fill="currentColor"
                                  stroke="currentColor"
                                  strokeWidth="0.3"/>
                        </svg>
                        :
                    <svg width="129" height="77" viewBox="0 0 129 77" fill="currentColor"
                         xmlns="http://www.w3.org/2000/svg"
                         style={iconStyles}>
                        <path
                            d="M125.327 74.7738H91.0261V72.1244H125.327V74.7738ZM59.2292 74.7738V53.6844H69.5991V74.7738H59.2292ZM40.0177 71.0418V29.0804H47.5281V74.7738H40.0177V71.0418ZM3.54907 72.1244H37.8516V74.7738H3.54907V72.1244ZM37.8516 69.9591H3.54907V29.0804H37.8516V69.9591ZM125.482 26.9138H3.39587L3.1084 25.0351H125.77L125.482 26.9138ZM81.3495 29.0804H88.8584V74.7738H81.3495V29.0804ZM69.8729 51.5178H59.0047C57.9333 51.5178 57.0609 52.3711 57.0609 53.4191V74.7738H49.6959V29.0804H79.1819V74.7738H71.7667V53.4191C71.7667 52.3711 70.9177 51.5178 69.8729 51.5178V51.5178ZM125.327 69.9591H91.0261V29.0804H125.327V69.9591ZM2.16613 18.4391H126.709V22.8698H2.16613V18.4391ZM22.9991 14.1551H32.7751L28.0704 16.2738H22.9991V14.1551ZM64.4385 2.2711L90.56 14.0351C90.5729 14.0418 90.5824 14.0524 90.5959 14.0591L95.5213 16.2738H33.3563L38.2824 14.0591C38.2969 14.0524 38.3073 14.0404 38.3213 14.0324L64.4385 2.2711ZM105.878 14.1551V16.2738H100.807L96.1021 14.1551H105.878ZM127.03 16.2738H108.045V13.6964C108.045 12.7538 107.28 11.9884 106.341 11.9884H91.2933L64.8839 0.0950892C64.6016 -0.0315774 64.2761 -0.0315774 63.9933 0.0950892L37.5844 11.9884H22.5355C21.5964 11.9884 20.8328 12.7538 20.8328 13.6964V16.2738H1.84587C0.810399 16.2738 0 17.0871 0 18.1258V23.2311C0 23.8764 0.351066 24.4391 0.873466 24.7578L1.3828 28.0804V71.0418V75.8577C1.3828 76.4551 1.8672 76.9404 2.46613 76.9404H38.9344H58.1453H70.6828H89.9423H126.411C127.009 76.9404 127.495 76.4551 127.495 75.8577V71.0418V28.0764L128.003 24.7578C128.526 24.4391 128.877 23.8764 128.877 23.2311V18.1258C128.877 17.0871 128.065 16.2738 127.03 16.2738"
                            fill="currentColor"/>
                        <path
                            d="M67.5968 46.8949H61.2785V34.0882H67.5968V46.8949ZM68.1567 31.9215H60.6728C59.7823 31.9215 59.1113 32.5935 59.1113 33.4855V47.4482C59.1113 48.3535 59.7973 49.0615 60.6728 49.0615H68.1567C69.0436 49.0615 69.7651 48.3375 69.7651 47.4482V33.4855C69.7651 32.6082 69.0588 31.9215 68.1567 31.9215Z"
                            fill="currentColor"/>
                        <path
                            d="M10.3185 34.0882H16.6857V46.8949H10.3185V34.0882ZM9.76074 49.0615H17.2441C18.131 49.0615 18.8523 48.3375 18.8523 47.4482V33.4855C18.8523 32.6082 18.1461 31.9215 17.2441 31.9215H9.76074C8.85914 31.9215 8.15234 32.6082 8.15234 33.4855V47.4482C8.15234 48.3375 8.87314 49.0615 9.76074 49.0615"
                            fill="currentColor"/>
                        <path
                            d="M24.7633 34.0882H31.13V46.8949H24.7633V34.0882ZM24.204 49.0615H31.6888C32.5748 49.0615 33.2956 48.3375 33.2956 47.4482V33.4855C33.2956 32.6082 32.5899 31.9215 31.6888 31.9215H24.204C23.3024 31.9215 22.5967 32.6082 22.5967 33.4855V47.4482C22.5967 48.3375 23.318 49.0615 24.204 49.0615Z"
                            fill="currentColor"/>
                        <path
                            d="M10.3185 53.2029H16.6857V66.0109H10.3185V53.2029ZM9.76074 68.1763H17.2441C18.1461 68.1763 18.8523 67.4896 18.8523 66.6123V52.6496C18.8523 51.7603 18.131 51.0363 17.2441 51.0363H9.76074C8.87314 51.0363 8.15234 51.7603 8.15234 52.6496V66.6123C8.15234 67.4896 8.85914 68.1763 9.76074 68.1763"
                            fill="currentColor"/>
                        <path
                            d="M24.7633 53.2029H31.13V66.0109H24.7633V53.2029ZM24.204 68.1763H31.6888C32.5899 68.1763 33.2956 67.4896 33.2956 66.6123V52.6496C33.2956 51.7603 32.5748 51.0363 31.6888 51.0363H24.204C23.318 51.0363 22.5967 51.7603 22.5967 52.6496V66.6123C22.5967 67.4896 23.3024 68.1763 24.204 68.1763Z"
                            fill="currentColor"/>
                        <path
                            d="M97.7483 34.0882H104.066V46.8949H97.7483V34.0882ZM97.1409 49.0615H104.673C105.519 49.0615 106.235 48.3242 106.235 47.4482V33.4855C106.235 32.6228 105.533 31.9215 104.673 31.9215H97.1409C96.2805 31.9215 95.5811 32.6228 95.5811 33.4855V47.4482C95.5811 48.3242 96.2951 49.0615 97.1409 49.0615Z"
                            fill="currentColor"/>
                        <path
                            d="M112.193 34.0882H118.51V46.8949H112.193V34.0882ZM111.585 49.0615H119.069C119.956 49.0615 120.678 48.3375 120.678 47.4482V33.4855C120.678 32.6082 119.972 31.9215 119.069 31.9215H111.585C110.697 31.9215 110.025 32.5935 110.025 33.4855V47.4482C110.025 48.3535 110.71 49.0615 111.585 49.0615"
                            fill="currentColor"/>
                        <path
                            d="M97.7483 53.2029H104.066V66.0109H97.7483V53.2029ZM97.1409 68.1763H104.673C105.533 68.1763 106.235 67.4749 106.235 66.6123V52.6496C106.235 51.7749 105.519 51.0363 104.673 51.0363H97.1409C96.2951 51.0363 95.5811 51.7749 95.5811 52.6496V66.6123C95.5811 67.4749 96.2805 68.1763 97.1409 68.1763Z"
                            fill="currentColor"/>
                        <path
                            d="M112.193 53.2029H118.51V66.0109H112.193V53.2029ZM111.585 68.1763H119.069C119.972 68.1763 120.678 67.4896 120.678 66.6123V52.6496C120.678 51.7603 119.956 51.0363 119.069 51.0363H111.585C110.71 51.0363 110.025 51.7456 110.025 52.6496V66.6123C110.025 67.5043 110.697 68.1763 111.585 68.1763"
                            fill="currentColor"/>
                    </svg>}

                </div>
                <span>{checkAndGetLocationName(location, weddingData)}</span>
                <br/>
                <span>{checkAndGetLocationLabel(location, weddingData)}
                    <br/> {moment(location.day).format('DD-MM-YYYY') !== moment(weddingData.dataEvent).format('DD-MM-YYYY') ?
                        moment(location.combinedDate).format('DD-MM-YYYY HH:mm') :
                        translateInviteTexts('la ora', lang, {date: moment(location.time).format('HH:mm')})}</span>
            </>)
    }
}

export const openLink = (link) => {
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler('openLink', link)
    } else if (window.alityAppView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
            action: 'openLink',
            url: link,
        }))
    } else {
        window.open(link)
    }
}

export const openMaps = (x, y, mode = 0) => {
    if (mode === 0) {
        openLink("http://maps.google.com/?q=" + x + "," + y);
    }
}

export const openWaze = (x, y, mode = 0) => {
    if (mode === 0) {
        openLink("https://www.waze.com/ul?ll=" + x + "%2C" + y + "&navigate=yes&zoom=17")
    }
}


export const getCustomClasses = (templateDetails, section, item) => {

    let classes = ''

    if (templateDetails[section] && templateDetails[section][item]) {
        Object.keys(templateDetails[section][item]).forEach((key) => {
            if (templateDetails[section][item][key] && key !== 'color' && key !== 'borderColor' && key !== 'activeColor') {
                classes += templateDetails[section][item][key] + ' '
            }
        })
    }

    return classes

}


export const getCustomStyles = (templateDetails, section, item, allowedStyles = ['color', 'textDecoration']) => {

    let style = {}

    if (templateDetails[section] && templateDetails[section][item]) {
        Object.keys(templateDetails[section][item]).forEach((key) => {

            if (allowedStyles && allowedStyles.includes(key)) {
                if (key === 'color') {
                    style = {...style, color: templateDetails[section][item][key]}
                }
                if (key === 'activeColor') {
                    style = {...style, color: templateDetails[section][item][key]}
                }
                if (key === 'borderColor') {
                    style = {...style, borderColor: templateDetails[section][item][key]}
                }
                if (key === 'textDecoration') {
                    style = {...style, textDecoration: templateDetails[section][item][key]}
                }

            }
        })
    }

    return style

}

export const getDefaultTemplateValues = (weddingData, templateId = 0, lang = 'ro', reset = ['invite', 'intro']) => {
    let templateDetails = {}
    let defaultTemplateValues = inviteTemplates.find((item) => item.id === templateId)

    if (reset.includes('invite')) {
        if (!defaultTemplateValues) {
            defaultTemplateValues = {}
            defaultTemplateValues.colors = {
                'baseColor': 'rgb(0,0,0)',
                'borderColor': '#000000',
                'fontColor': '#000000'
            }
        }

        if (!defaultTemplateValues.colors) {
            defaultTemplateValues.colors = {
                'baseColor': 'rgb(0,0,0)',
                'borderColor': '#000000',
                'fontColor': '#000000'
            }
        }

        if(!defaultTemplateValues.fonts) {
            defaultTemplateValues.fonts = {
                general: 'style-font-dancing-script'
            }
        }

        if(!defaultTemplateValues.config) {
            defaultTemplateValues.config = {}
        }

        if (weddingData.data.eventType === 'Nunta') {

            templateDetails = {
                eventType: weddingData.data.eventType,
                section1: {
                    text1: translateInviteTexts('Cu inimile pline de emoție și bucurie, noi', lang),
                    brideName: weddingData.data.prenumeMireasa ? weddingData.data.prenumeMireasa : translateInviteTexts('Mireasă', lang),
                    groomName: weddingData.data.prenumeMire ? weddingData.data.prenumeMire : translateInviteTexts('Mire', lang),
                    text2: translateInviteTexts('Vă invităm să fiți alături de noi la celebrarea căsătoriei noastre.', lang),
                    image1: false,
                    image2: false,
                    coverImage: false
                },
                section2: {
                    date: weddingData.data.dataEvent ? weddingData.data.dataEvent : '2022-08-27T01:02:00.000',
                    text1: translateInviteTexts("Alături ne vor fi părinții", lang),
                    groomParents: translateInviteTexts("Soț & Soție", lang),
                    brideParents: translateInviteTexts("Soț & Soție", lang),
                    text2: translateInviteTexts("Și nașii", lang),
                    text3: translateInviteTexts("Nașul & Nașa", lang),
                },
                section3: {
                    text4: translateInviteTexts("Vă așteptăm cu drag!", lang)
                },
            }


            //Define styles
            templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.groomNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.groomNameStyles
            }
            templateDetails.section1.separatorStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.separatorStyles
            }
            templateDetails.section1.brideNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.brideNameStyles
            }
            templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.childrenNameStyles = {'color': defaultTemplateValues.colors.fontColor}

            templateDetails.section2.dateStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'activeColor': defaultTemplateValues.colors.baseColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section2.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section2.groomParentsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section2.brideParentsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section2.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section2.text3Styles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }

            templateDetails.section3.locationsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}
        }

        if (weddingData.data.eventType === 'Cununie') {

            templateDetails = {
                eventType: weddingData.data.eventType,
                section1: {
                    text1: translateInviteTexts('Cu inimile pline de emoție și bucurie, noi', lang),
                    brideName: weddingData.data.prenumeMireasa ? weddingData.data.prenumeMireasa : translateInviteTexts('Mireasă', lang),
                    groomName: weddingData.data.prenumeMire ? weddingData.data.prenumeMire : translateInviteTexts('Mire', lang),
                    text2: translateInviteTexts('Vă invităm să fiți alături de noi la celebrarea cununiei noastre.', lang),
                    image1: false,
                    image2: false,
                    coverImage: false
                },
                section2: {
                    date: weddingData.data.dataEvent ? weddingData.data.dataEvent : '2022-08-27T01:02:00.000',
                    text1: translateInviteTexts("Alături ne vor fi părinții", lang),
                    groomParents: translateInviteTexts("Soț & Soție", lang),
                    brideParents: translateInviteTexts("Soț & Soție", lang),
                    text2: translateInviteTexts("Și nașii", lang),
                    text3: translateInviteTexts("Nașul & Nașa", lang),
                },
                section3: {
                    text4: translateInviteTexts("Vă așteptăm cu drag!", lang)
                }
            }


            //Define styles
            templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.groomNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.groomNameStyles
            }
            templateDetails.section1.separatorStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.separatorStyles
            }
            templateDetails.section1.brideNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.brideNameStyles
            }
            templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}

            templateDetails.section2.dateStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'activeColor': defaultTemplateValues.colors.baseColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section2.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section2.groomParentsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section2.brideParentsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section2.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section2.text3Styles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }

            templateDetails.section3.locationsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}
        }

        if (weddingData.data.eventType === 'Botez') {
            templateDetails = {
                eventType: weddingData.data.eventType,
                section1: {
                    text1: translateInviteTexts('Sunt cel mai frumos dar pe care Dumnezeu l-a făcut părinților mei și mă numesc', lang),
                    brideName: weddingData.data.prenumeMireasa ? weddingData.data.prenumeMireasa : translateInviteTexts('Copil', lang),
                    groomName: weddingData.data.prenumeMire ? weddingData.data.prenumeMire : translateInviteTexts('Copil', lang),
                    text2: translateInviteTexts('Împreună cu părinții mei,', lang),
                    parents: weddingData.data.prenumeMama ? weddingData.data.prenumeTata + ' & ' + weddingData.data.prenumeMama : translateInviteTexts('Soț & Soție', lang),
                    text3: translateInviteTexts('Având alături nașii,', lang),
                    text4: translateInviteTexts('Nașul & Nașa', lang),
                    text5: translateInviteTexts('Avem plăcerea de a vă invita la botezul meu', lang),
                    image1: false,
                    image2: false
                },
                section2: {
                    date: weddingData.data.dataEvent ? weddingData.data.dataEvent : '2022-08-27T01:02:00.000'
                },
                section3: {
                    text4: translateInviteTexts("Vă așteptăm cu drag!", lang)
                }
            }

            //Define styles
            templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.groomNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.groomNameStyles
            }
            templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.parentsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section1.text3Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.text4Styles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section1.text5Styles = {'color': defaultTemplateValues.colors.fontColor}

            templateDetails.section2.dateStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'activeColor': defaultTemplateValues.colors.baseColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section2.locationsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }


            templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}
        }

        if (weddingData.data.eventType === 'Mot') {
            templateDetails = {
                eventType: weddingData.data.eventType,
                section1: {
                    text1: translateInviteTexts('Sunt cel mai frumos dar pe care Dumnezeu l-a făcut părinților mei și mă numesc', lang),
                    brideName: weddingData.data.prenumeMireasa ? weddingData.data.prenumeMireasa : translateInviteTexts('Copil', lang),
                    groomName: weddingData.data.prenumeMire ? weddingData.data.prenumeMire : translateInviteTexts('Copil', lang),
                    text2: translateInviteTexts('Împreună cu părinții mei,', lang),
                    parents: weddingData.data.prenumeMama ? weddingData.data.prenumeTata + ' & ' + weddingData.data.prenumeMama : translateInviteTexts('Soț & Soție', lang),
                    text3: translateInviteTexts('Având alături nașii,', lang),
                    text4: translateInviteTexts('Nașul și Nașa', lang),
                    text5: translateInviteTexts('Avem plăcerea de a vă invita la tăierea moțului meu', lang),
                    image1: false,
                    image2: false
                },
                section2: {
                    date: weddingData.data.dataEvent ? weddingData.data.dataEvent : '2022-08-27T01:02:00.000'
                },
                section3: {
                    text4: translateInviteTexts("Vă așteptăm cu drag!", lang)
                }
            }

            //Define styles
            templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.groomNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.groomNameStyles
            }
            templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.parentsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section1.text3Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.text4Styles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section1.text5Styles = {'color': defaultTemplateValues.colors.fontColor}

            templateDetails.section2.dateStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'activeColor': defaultTemplateValues.colors.baseColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section2.locationsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }


            templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}
        }

        if (weddingData.data.eventType === 'Turta') {
            templateDetails = {
                eventType: weddingData.data.eventType,
                section1: {
                    text1: translateInviteTexts('Sunt cel mai frumos dar pe care Dumnezeu l-a făcut părinților mei și mă numesc', lang),
                    brideName: weddingData.data.prenumeMireasa ? weddingData.data.prenumeMireasa : translateInviteTexts('Copil', lang),
                    groomName: weddingData.data.prenumeMire ? weddingData.data.prenumeMire : translateInviteTexts('Copil', lang),
                    text2: translateInviteTexts('Împreună cu părinții mei,', lang),
                    parents: weddingData.data.prenumeMama ? weddingData.data.prenumeTata + ' & ' + weddingData.data.prenumeMama : translateInviteTexts('Soț & Soție', lang),
                    text3: translateInviteTexts('Având alături nașii,', lang),
                    text4: translateInviteTexts('Nașul & Nașa', lang),
                    text5: translateInviteTexts('Avem plăcerea de a vă invita la ruperea turtei mele', lang),
                    image1: false,
                    image2: false
                },
                section2: {
                    date: weddingData.data.dataEvent ? weddingData.data.dataEvent : '2022-08-27T01:02:00.000'
                },
                section3: {
                    text4: translateInviteTexts("Vă așteptăm cu drag!", lang)
                }
            }

            //Define styles
            templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.groomNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.groomNameStyles
            }
            templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.parentsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section1.text3Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.text4Styles = {
                'color': defaultTemplateValues.colors.fontColor,
                textDecoration: 'underline'
            }
            templateDetails.section1.text5Styles = {'color': defaultTemplateValues.colors.fontColor}

            templateDetails.section2.dateStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'activeColor': defaultTemplateValues.colors.baseColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section2.locationsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }


            templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}
        }

        if (weddingData.data.eventType === 'Petrecere') {
            templateDetails = {
                eventType: weddingData.data.eventType,
                section1: {
                    brideName: weddingData.data.prenumeMireasa ? weddingData.data.prenumeMireasa : translateInviteTexts('Aniversarea mea', lang),
                    groomName: weddingData.data.prenumeMire ? weddingData.data.prenumeMire : translateInviteTexts('Aniversarea mea', lang),
                    text2: translateInviteTexts('Vă invităm să ne distrăm împreună', lang),
                    image1: false,
                    image2: false
                },
                section2: {
                    date: weddingData.data.dataEvent ? weddingData.data.dataEvent : '2022-08-27T01:02:00.000'
                },
                section3: {
                    text4: translateInviteTexts("Vă așteptăm cu drag!", lang)
                }
            }

            //Define styles
            templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
            templateDetails.section1.groomNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                ...defaultTemplateValues.config.groomNameStyles
            }
            templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}

            templateDetails.section2.dateStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'activeColor': defaultTemplateValues.colors.baseColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section2.locationsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'borderColor': defaultTemplateValues.colors.borderColor
            }
            templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}
        }

        if (corporateWeddingEvents.includes(weddingData.data.eventType)) {
            templateDetails = {
                eventType: weddingData.data.eventType,
                section1: {
                    text1: translateInviteTexts('Vă invităm la evenimentul nostru', lang),
                    brideName: weddingData.data.prenumeMireasa ? weddingData.data.prenumeMireasa : translateInviteTexts('Denumire eveniment business', lang),
                    groomName: weddingData.data.prenumeMire ? weddingData.data.prenumeMire : translateInviteTexts('Denumire eveniment business', lang),
                    text2: translateInviteTexts('Adaugă aici descrierea evenimentului', lang),
                    image1: false,
                    image2: false
                },
                section2: {
                    date: weddingData.data.dataEvent ? weddingData.data.dataEvent : '2022-08-27T01:02:00.000'
                },
                section3: {
                    text4: translateInviteTexts("Vă așteptăm cu drag!", lang)
                }
            }

            //Define styles
            templateDetails.section1.text1Styles = {
                'color': defaultTemplateValues.colors.fontColor,
                'font': getDefaultTemplateConfigFont('text1Styles', defaultTemplateValues)
            }
            templateDetails.section1.groomNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'font': getDefaultTemplateConfigFont('groomNameStyles', defaultTemplateValues),
                ...defaultTemplateValues.config.groomNameStyles
            }
            templateDetails.section1.text2Styles = {
                'color': defaultTemplateValues.colors.fontColor,
                'font': getDefaultTemplateConfigFont('text2Styles', defaultTemplateValues)
            }

            templateDetails.section2.dateStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'activeColor': defaultTemplateValues.colors.baseColor,
                'borderColor': defaultTemplateValues.colors.borderColor,
                'font': getDefaultTemplateConfigFont('dateStyles', defaultTemplateValues)
            }
            templateDetails.section2.locationsStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'borderColor': defaultTemplateValues.colors.borderColor,
                'font': getDefaultTemplateConfigFont('locationsStyles', defaultTemplateValues)
            }
            templateDetails.section3.text4Styles = {
                'color': defaultTemplateValues.colors.fontColor,
                'font': getDefaultTemplateConfigFont('text4Styles', defaultTemplateValues)
            }
        }
    }

    if (weddingData.data.invite && weddingData.data.invite.templateDetails && weddingData.data.invite.templateDetails.introAnimationId && weddingData.data.invite.templateDetails.introAnimationConfiguration) {
        templateDetails.introAnimations = weddingData.data.invite.templateDetails.introAnimations
        templateDetails.introAnimationId = defaultTemplateValues.introAnimations && defaultTemplateValues.introAnimations.length > 0 ?
            defaultTemplateValues.introAnimations[0] : null
        templateDetails.introAnimationConfiguration = weddingData.data.invite.templateDetails.introAnimationConfiguration
    }

    if (reset.includes('intro')) {
        if (defaultTemplateValues.introScreen && defaultTemplateValues.introScreen.config) {
            templateDetails.introScreenSection1 = {
                "brideName": weddingData.data.prenumeMireasa ? weddingData.data.prenumeMireasa : translateInviteTexts('Mireasă', lang),
                "groomName": weddingData.data.prenumeMire ? weddingData.data.prenumeMire : translateInviteTexts('Mire', lang),
                "dateStyles": {
                    'color': defaultTemplateValues.colors.fontColor,
                    'activeColor': defaultTemplateValues.colors.baseColor,
                    'borderColor': defaultTemplateValues.colors.borderColor,
                    'font': getDefaultTemplateConfigFont('dateStyles', defaultTemplateValues)
                },
                "envelopeColor": {color: defaultTemplateValues.introScreen.config.envelopeColor},
                "groomNameStyles": {
                    'color': defaultTemplateValues.colors.fontColor,
                    'font': getDefaultTemplateConfigFont('groomNameStyles', defaultTemplateValues),
                    ...defaultTemplateValues.introScreen.config.groomNameStyles
                },
                "separatorStyles": {
                    'color': defaultTemplateValues.colors.fontColor,
                    'font': getDefaultTemplateConfigFont('separatorStyles', defaultTemplateValues)
                },
                "brideNameStyles": {
                    'color': defaultTemplateValues.colors.fontColor,
                    'font': getDefaultTemplateConfigFont('brideNameStyles', defaultTemplateValues)
                },
                "envelopeTextStyle": {
                    'color': defaultTemplateValues.introScreen.config.fontColor,
                    'font': getDefaultTemplateConfigFont('envelopeTextStyle', defaultTemplateValues)
                },
                "envelopeText": translateInviteTexts("Apasă pentru a deschide invitația", lang)
            }
            templateDetails.introScreenSection2 = {
                "confirmButtonIconColor": {'color': defaultTemplateValues.introScreen.config.fontColor},
                "viewLocationButtonIconColor": {'color': defaultTemplateValues.introScreen.config.fontColor},
                "openInvitationButtonIconColor": {'color': defaultTemplateValues.introScreen.config.fontColor},
                "text4": translateInviteTexts("Vă așteptăm cu drag!", lang),
                "text4Styles": {
                    'color': defaultTemplateValues.colors.fontColor,
                    'font': getDefaultTemplateConfigFont('text4Styles', defaultTemplateValues)
                },
                "showConfirmButton": true,
                "confirmButtonColor": templateDetails.introScreenSection1.envelopeColor,
                "confirmButtonFontStyles": {
                    'font': getDefaultTemplateConfigFont('confirmButtonFont', defaultTemplateValues)
                },
                "showViewLocationButton": true,
                "viewLocationButtonColor": templateDetails.introScreenSection1.envelopeColor,
                "viewLocationButtonFontStyles": {
                    'font': getDefaultTemplateConfigFont('viewLocationButtonFont', defaultTemplateValues)
                },
                "showOpenInvitationButton": true,
                "openInvitationButtonColor": templateDetails.introScreenSection1.envelopeColor,
                "openInvitationButtonFontStyles": {
                    'font': getDefaultTemplateConfigFont('openInvitationButtonFont', defaultTemplateValues)
                },
            }
        } else {
            templateDetails.introScreenSection1 = null
            templateDetails.introScreenSection2 = null
        }
        if (weddingData.data.invite && weddingData.data.invite.templateDetails && defaultTemplateValues.introScreen &&
            weddingData.data.invite.templateDetails.introScreenId && weddingData.data.invite.templateDetails.introScreenConfiguration) {
            templateDetails.introScreenId = defaultTemplateValues.introScreen.templateId ?? null
            templateDetails.introScreenConfiguration = defaultTemplateValues.introScreen.config ?? []
        }
    } else {
        if (weddingData.data.invite && weddingData.data.invite.templateDetails && weddingData.data.invite.templateDetails.introScreenSection1 && weddingData.data.invite.templateDetails.introScreenSection2) {
            templateDetails.introScreenSection1 = weddingData.data.invite.templateDetails.introScreenSection1
            templateDetails.introScreenSection2 = weddingData.data.invite.templateDetails.introScreenSection2
        }
        if (weddingData.data.invite && weddingData.data.invite.templateDetails && weddingData.data.invite.templateDetails.introScreenId && weddingData.data.invite.templateDetails.introScreenConfiguration) {
            templateDetails.introScreenId = defaultTemplateValues.introScreen.templateId ?? null
            templateDetails.introScreenConfiguration = defaultTemplateValues.introScreen.config ?? []
        }
    }

    //Custom variables
    templateDetails.coverImage = defaultTemplateValues && defaultTemplateValues.coverImage ? true : false
    templateDetails.coverImageDefault = defaultTemplateValues && defaultTemplateValues.coverImageDefault ? defaultTemplateValues.coverImageDefault : ''

    return templateDetails

}

export const resetTemplateStyles = (templateDetails) => {

    let defaultTemplateValues = inviteTemplates.find((item) => item.id === templateDetails.id)

    if (!defaultTemplateValues) {
        defaultTemplateValues = {}
        defaultTemplateValues.colors = {
            'baseColor': 'rgb(0,0,0)',
            'borderColor': '#000000',
            'fontColor': '#000000'
        }
    }

    if (!defaultTemplateValues.colors) {
        defaultTemplateValues.colors = {
            'baseColor': 'rgb(0,0,0)',
            'borderColor': '#000000',
            'fontColor': '#000000'
        }
    }

    if(!defaultTemplateValues.fonts) {
        defaultTemplateValues.fonts = {
            general: 'style-font-dancing-script'
        }
    }

    if(!defaultTemplateValues.config) {
        defaultTemplateValues.config = {}
    }

    if (templateDetails.eventType === 'Nunta' || templateDetails.eventType === 'Cununie') {

        templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
        templateDetails.section1.groomNameStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            ...defaultTemplateValues.config.groomNameStyles
        }
        templateDetails.section1.separatorStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            ...defaultTemplateValues.config.separatorStyles
        }
        templateDetails.section1.brideNameStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            ...defaultTemplateValues.config.brideNameStyles
        }
        templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
        templateDetails.section1.childrenNameStyles = {'color': defaultTemplateValues.colors.fontColor}

        templateDetails.section2.dateStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'activeColor': defaultTemplateValues.colors.baseColor,
            'borderColor': defaultTemplateValues.colors.borderColor
        }
        templateDetails.section2.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
        templateDetails.section2.groomParentsStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            textDecoration: 'underline'
        }
        templateDetails.section2.brideParentsStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            textDecoration: 'underline'
        }
        templateDetails.section2.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
        templateDetails.section2.text3Styles = {
            'color': defaultTemplateValues.colors.fontColor,
            textDecoration: 'underline'
        }

        templateDetails.section3.locationsStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'borderColor': defaultTemplateValues.colors.borderColor
        }
        templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}

    }

    if (templateDetails.eventType === 'Botez' || templateDetails.eventType === 'Mot' || templateDetails.eventType === 'Turta') {
        //Define styles
        templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
        templateDetails.section1.groomNameStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            ...defaultTemplateValues.config.groomNameStyles
        }
        templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}
        templateDetails.section1.parentsStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            textDecoration: 'underline'
        }
        templateDetails.section1.text3Styles = {'color': defaultTemplateValues.colors.fontColor}
        templateDetails.section1.text4Styles = {
            'color': defaultTemplateValues.colors.fontColor,
            textDecoration: 'underline'
        }
        templateDetails.section1.text5Styles = {'color': defaultTemplateValues.colors.fontColor}

        templateDetails.section2.dateStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'activeColor': defaultTemplateValues.colors.baseColor,
            'borderColor': defaultTemplateValues.colors.borderColor
        }
        templateDetails.section2.locationsStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'borderColor': defaultTemplateValues.colors.borderColor
        }
        templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}
    }

    if (templateDetails.eventType === 'Petrecere') {
        //Define styles
        templateDetails.section1.text1Styles = {'color': defaultTemplateValues.colors.fontColor}
        templateDetails.section1.groomNameStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            ...defaultTemplateValues.config.groomNameStyles
        }
        templateDetails.section1.text2Styles = {'color': defaultTemplateValues.colors.fontColor}

        templateDetails.section2.dateStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'activeColor': defaultTemplateValues.colors.baseColor,
            'borderColor': defaultTemplateValues.colors.borderColor
        }
        templateDetails.section2.locationsStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'borderColor': defaultTemplateValues.colors.borderColor
        }
        templateDetails.section3.text4Styles = {'color': defaultTemplateValues.colors.fontColor}
    }

    if (corporateWeddingEvents.includes(templateDetails.eventType)) {
        //Define styles
        templateDetails.section1.text1Styles = {
            'color': defaultTemplateValues.colors.fontColor,
            'font': getDefaultTemplateConfigFont('text1Styles', defaultTemplateValues)
        }
        templateDetails.section1.groomNameStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'font': getDefaultTemplateConfigFont('groomNameStyles', defaultTemplateValues),
            ...defaultTemplateValues.config.groomNameStyles
        }
        templateDetails.section1.text2Styles = {
            'color': defaultTemplateValues.colors.fontColor,
            'font': getDefaultTemplateConfigFont('text2Styles', defaultTemplateValues)
        }

        templateDetails.section2.dateStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'activeColor': defaultTemplateValues.colors.baseColor,
            'borderColor': defaultTemplateValues.colors.borderColor,
            'font': getDefaultTemplateConfigFont('dateStyles', defaultTemplateValues)
        }
        templateDetails.section2.locationsStyles = {
            'color': defaultTemplateValues.colors.fontColor,
            'borderColor': defaultTemplateValues.colors.borderColor,
            'font': getDefaultTemplateConfigFont('locationsStyles', defaultTemplateValues)
        }
        templateDetails.section3.text4Styles = {
            'color': defaultTemplateValues.colors.fontColor,
            'font': getDefaultTemplateConfigFont('text4Styles', defaultTemplateValues)
        }
    }

    //Custom variables
    templateDetails.coverImage = defaultTemplateValues && defaultTemplateValues.coverImage ? true : false
    templateDetails.coverImageDefault = defaultTemplateValues && defaultTemplateValues.coverImageDefault ? defaultTemplateValues.coverImageDefault : ''


    return templateDetails
}
export const resetTemplateIntroScreenStyles = (templateDetails) => {
    let defaultTemplateValues = inviteTemplates.find((item) => item.id === templateDetails.id)
    if (defaultTemplateValues.introScreen && defaultTemplateValues.introScreen.config) {

        if (templateDetails.introScreenSection1 && templateDetails.introScreenSection2) {
            templateDetails.introScreenSection1.dateStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'activeColor': defaultTemplateValues.colors.baseColor,
                'borderColor': defaultTemplateValues.colors.borderColor,
                'font': getDefaultTemplateConfigFont('dateStyles', defaultTemplateValues),
            }
            templateDetails.introScreenSection1.envelopeColor = {color: defaultTemplateValues.introScreen.config.envelopeColor}
            templateDetails.introScreenSection1.groomNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'font': getDefaultTemplateConfigFont('groomNameStyles', defaultTemplateValues),
                ...defaultTemplateValues.introScreen.config.groomNameStyles
            }
            templateDetails.introScreenSection1.separatorStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'font': getDefaultTemplateConfigFont('separatorStyles', defaultTemplateValues)
            }
            templateDetails.introScreenSection1.brideNameStyles = {
                'color': defaultTemplateValues.colors.fontColor,
                'font': getDefaultTemplateConfigFont('brideNameStyles', defaultTemplateValues)
            }
            templateDetails.introScreenSection1.envelopeTextStyle = {
                'color': defaultTemplateValues.introScreen.config.fontColor,
                'font': getDefaultTemplateConfigFont('envelopeTextStyle', defaultTemplateValues)
            }

            templateDetails.introScreenSection2.text4Styles = templateDetails.section3.text4Styles
            templateDetails.introScreenSection2.confirmButtonColor = templateDetails.introScreenSection1.envelopeColor
            templateDetails.introScreenSection2.viewLocationButtonColor = templateDetails.introScreenSection1.envelopeColor
            templateDetails.introScreenSection2.openInvitationButtonColor = templateDetails.introScreenSection1.envelopeColor

            templateDetails.introScreenSection2.confirmButtonIconColor = {'color': defaultTemplateValues.introScreen.config.fontColor}
            templateDetails.introScreenSection2.confirmButtonFontStyles = {
                'color': defaultTemplateValues.introScreen.config.fontColor,
                'font': getDefaultTemplateConfigFont('confirmButtonFont', defaultTemplateValues)
            }
            templateDetails.introScreenSection2.viewLocationButtonIconColor = {'color': defaultTemplateValues.introScreen.config.fontColor}
            templateDetails.introScreenSection2.viewLocationButtonFontStyles = {
                'color': defaultTemplateValues.introScreen.config.fontColor,
                'font': getDefaultTemplateConfigFont('viewLocationButtonFont', defaultTemplateValues)
            }
            templateDetails.introScreenSection2.openInvitationButtonIconColor = {'color': defaultTemplateValues.introScreen.config.fontColor}
            templateDetails.introScreenSection2.openInvitationButtonFontStyles = {
                'color': defaultTemplateValues.introScreen.config.fontColor,
                'font': getDefaultTemplateConfigFont('openInvitationButtonFont', defaultTemplateValues)
            }
        }

    } else {
        templateDetails.introScreenSection1 = null
        templateDetails.introScreenSection2 = null
    }

    return templateDetails
}

export function getEditSectionTitle(section, eventType) {

    if (eventType === 'Nunta' || eventType === 'Cununie') {
        if (section === 1) {
            return 'Editează nume / prenume, descriere'
        }
        if (section === 2) {
            return 'Editează data evenimentului, nume părinți / nași'
        }
        if (section === 3) {
            return 'Editează locații + text de confirmare'
        }
    }

    if (eventType === 'Botez' || eventType === 'Mot' || eventType === 'Turta') {
        if (section === 1) {
            return 'Editează nume / prenume, părinți,nași'
        }
        if (section === 2) {
            return 'Editează data evenimentului, locații'
        }
        if (section === 3) {
            return 'Editează fraza de încheiere'
        }
    }

    if (eventType === 'Petrecere') {
        if (section === 1) {
            return 'Editează titlul, descrierea, fotografia'
        }
        if (section === 2) {
            return 'Editează data evenimentului, locații'
        }
        if (section === 3) {
            return 'Editează fraza de încheiere'
        }
    }

    return 'Editează'


}

export function getEditSectionTitleForIntroScreen(section, eventType) {

    if (section === 2) {
        return 'Editează fraza de încheiere, butoanele'
    }
    if (eventType === 'Nunta' || eventType === 'Cununie' || eventType === 'Botez' || eventType === 'Mot' || eventType === 'Turta') {
        if (section === 1) {
            return 'Editează nume / prenume, plic'
        }
    }

    if (eventType === 'Petrecere') {
        if (section === 1) {
            return 'Editează titlul, descrierea, fotografia'
        }
    }

    return 'Editează'


}

export const getTemplateConfigValues = (templateId) => {
    return inviteTemplates.find((item) => item.id === templateId)
}

export const getIntroAnimationConfigValues = (id) => {
    return introAnimations.find((item) => item.id === id)
}

export function getDefaultTemplateConfigFont(slug, defaultTemplateValues) {
    return defaultTemplateValues.fonts ?
        defaultTemplateValues.fonts[slug] ? defaultTemplateValues.fonts[slug] : defaultTemplateValues.fonts.general
        : ''
}

export const getAnimationScreenTemplateConfigValues = (id) => {
    return introAnimation2ScreenTemplatesConfig.find((item) => item.id === id)
}

export const getAnimation2PredefinedSets = (eventType, inviteTemplateId) => {
    //TODO custom sets for each invite template

    return introAnimation2PredefinedSets[eventType]
}

